(ns frontend.test.dropdown-with-sections
  (:require
   [frontend.routing :as routing]
   [reagent.core :as r]
   [frontend.state.current-session :as session]
   [frontend.ux-overhaul.components.select-with-filter.view :as dropdown]))

(def groups
  [{:label   "Group 1"
    :options [{:value "item 11"
               :label "item 11"}
              {:value "item 12"
               :label "item 12"}]}
   {:label   "Group 2"
    :options [{:value "item 21"
               :label "item 21"}
              {:value "item 22"
               :label "item 22"}
              {:value "item 23"
               :label "item 23"}
              {:value "item 24"
               :label "item 24"}]}])

(defmethod routing/render-view :test/dropdown-with-sections
  [{:keys [route-params]}]
  (let [state (r/atom {:value "item 11"})]
    [:div.p-5 {:style {:background "#fafafa" :height "100vh"}}
     "Hello"
     [:div.pt-3
      {:style {:max-width "250px"}}
      [dropdown/view
       {:state-atom state
        :groups     groups}]]]))
